// extracted by mini-css-extract-plugin
module.exports = {"container":"context-menu_container__1RCEQ"};